import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uefa-player-table" }
const _hoisted_2 = { class: "uefa-player-table__table" }
const _hoisted_3 = {
  class: "uefa-player-table__head uefa-player-table__head--item",
  colspan: "3"
}
const _hoisted_4 = { class: "uefa-player-table__cell" }
const _hoisted_5 = { class: "uefa-player-table__cell uefa-player-table__cell--item" }
const _hoisted_6 = { class: "uefa-player-table__item" }
const _hoisted_7 = { class: "uefa-player-table__img-wrapper" }
const _hoisted_8 = ["src", "onerror"]
const _hoisted_9 = { class: "uefa-player-table__name" }
const _hoisted_10 = {
  key: 0,
  class: "uefa-player-table__description"
}
const _hoisted_11 = { class: "uefa-player-table__cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.title), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, i) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(i + 1), 1),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (content.img)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "uefa-player-table__img",
                        src: content.img,
                        width: "48",
                        loading: "lazy",
                        onerror: `this.onerror=null; this.src='/uefa/avatar.png';`
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("strong", null, _toDisplayString(content.name), 1),
                  (content.team)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(content.team), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_11, _toDisplayString(content.value), 1)
          ]))
        }), 256))
      ])
    ])
  ]))
}